(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6360],{

/***/ 51647:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/estates",
      function () {
        return __webpack_require__(61960);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 1860:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ page; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(89736);

var page = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)({
    pageId: -1,
    isMobile: 0,
    isTablet: 0,
    isDesktop: 0,
    isPublicDomain: 0,
    appSettings: [],
    destinationId: null,
    propertiesParams: {
        page_id: null,
        limit: 24,
        offset: 0,
        destinations: [],
        tags: [],
        themes: [],
        locations: [],
        statuses: 3
    }
});


/***/ }),

/***/ 61960:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Estates": function() { return /* binding */ Estates; },
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(82770);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(4012);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(14140);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(89736);
/* harmony import */ var _fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95623);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(18256);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _components_AppContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(1860);
/* harmony import */ var _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83974);
/* harmony import */ var _fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(54197);
/* harmony import */ var _fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_fortawesome_fontawesome_svg_core_styles_css__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(46797);
/* harmony import */ var _components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(56951);
/* harmony import */ var _components_templates_index_partials_InlineStyles__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(53408);
/* harmony import */ var _layouts_MainLayout__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28207);









_fortawesome_fontawesome_svg_core__WEBPACK_IMPORTED_MODULE_2__/* .config.autoAddCss */ .vc.autoAddCss = false;




var Header = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 60314));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(60314)
            ];
        }
    },
    suspense: true
});
var Properties = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(5175), __webpack_require__.e(4795), __webpack_require__.e(4136)]).then(__webpack_require__.bind(__webpack_require__, 34136));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(34136)
            ];
        }
    },
    suspense: true
});
var BottomSections = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 64481));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(64481)
            ];
        }
    },
    suspense: true
});
var Scripts = next_dynamic__WEBPACK_IMPORTED_MODULE_3___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(7452), __webpack_require__.e(9764), __webpack_require__.e(5419)]).then(__webpack_require__.bind(__webpack_require__, 85419));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(85419)
            ];
        }
    },
    ssr: false
});
var __N_SSP = true;
var Estates = function(props) {
    var pageContext = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(_components_AppContext__WEBPACK_IMPORTED_MODULE_4__/* .page */ .M);
    pageContext.pageId = props.app_data.page_id;
    pageContext.isMobile = props.isMobile;
    pageContext.isTablet = props.isTablet;
    pageContext.isDesktop = props.isDesktop;
    pageContext.appSettings = props.app;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null), urlHref = ref[0], setUrlHref = ref[1];
    react__WEBPACK_IMPORTED_MODULE_1__.useEffect(function() {
        _fancyapps_ui_dist_fancybox_esm__WEBPACK_IMPORTED_MODULE_7__/* .Fancybox.bind */ .KR.bind("[data-fancybox]", {
            Image: {
                zoom: false
            }
        });
        if (window !== undefined) {
            setUrlHref(window.location.href + "/");
        }
    }, [
        urlHref
    ]);
    var domain = props.domain;
    var app = props.app;
    var builder = props.builder;
    var head = props.head;
    var footer = props.footer;
    var app_data = props.app_data;
    var navigation = props.navigation;
    var properties = props.properties;
    var rgbDesignColor = props.rgbDesignColor;
    var rgbSearchbarColor = props.rgbSearchbarColor;
    var isDesktop = props.isDesktop;
    var title = "Villas Collection | " + head.data.title;
    var meta_desc = head.data.motto;
    var image_fb_meta = _helpers_class_Checkers__WEBPACK_IMPORTED_MODULE_5__/* ["default"].isValidArray */ .Z.isValidArray(head.og_image) ? head.og_image[0].image : null;
    var contactIcons = {
        phoneIcon: app.showPhoneIconOnMenu,
        chatIcon: app.showChatIconOnMenu,
        mailIcon: app.showMailIconOnMenu,
        phoneIconData: app.menuPhoneIconData,
        chatIconData: app.menuChatIconData,
        mailIconData: app.menuMailIconData
    };
    // const containerClass = Checkers.googleMapsPropertyInit( app.googleMapsApiKey, app.viewMap, 0, 0 ) ? 'container-fluid px-2 px-md-3' : 'container';
    var containerClass = "container";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_layouts_MainLayout__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)({}, props), {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_templates_index_partials_InlineStyles__WEBPACK_IMPORTED_MODULE_9__/* .InlineStyles */ .f, {
                app: app,
                rgbDesignColor: rgbDesignColor,
                rgbSearchbarColor: rgbSearchbarColor
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_head_BuilderHead__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                title: title,
                titleOfficial: head.data.titleOfficial,
                domain: urlHref,
                icon_60: head.data.icon_60,
                icon_76: head.data.icon_76,
                icon_120: head.data.icon_120,
                icon_152: head.data.icon_152,
                icon_256: head.data.icon_256,
                icon: head.data.icon,
                title_fb_meta: title,
                desc_fb_meta: meta_desc,
                image_fb_meta: image_fb_meta,
                site_name_fb_meta: head.data.title,
                lat_fb_meta: head.location.latitude,
                lon_fb_meta: head.location.longitude,
                twitter_img_alt: title + meta_desc,
                googleSchemaContext: domain,
                googleSchemaTitle: head.data.title,
                googleSchemaStreetAddress: head.location[0].address,
                googleSchemaCity: head.location[0].city,
                googleSchemaCountry: head.location[0].country,
                googleSchemaZip: head.location[0].zip,
                googleSchemaPhone: head.location[0].phone,
                designColor: app.designColor,
                font: app.font,
                manager: false,
                property: true
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Suspense, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Properties, {
                    app: app,
                    builder: builder,
                    propertiesIndex: true,
                    propertiesParams: props.propertiesParams,
                    properties_count: props.properties_count,
                    designMode: app.designMode,
                    searchbarRadius: app.searchbarRadius,
                    searchbarShadow: app.searchbarShadow,
                    bookingSearchbarWithBedrooms: app.bookingSearchbarWithBedrooms,
                    googleMapShow: app.viewMap,
                    googleMapApiKey: app.googleMapsApiKey,
                    propertiesFilters: props.propertiesFilters,
                    showBookingBar: false
                })
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (Estates);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5693,4285,8201,8340,9007,5553,5634,9656,8024,6442,8207,1345,9774,2888,179], function() { return __webpack_exec__(51647); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);